<ng-container *transloco="let t; read: 'ime.common.units'">
  <ng-select #select class="select-sm form-control"
             [items]="allItems$ | async"
             [name]="name"
             [searchFn]="searchFn"
             [clearable]="clearable"
             [readonly]="readonly"
             [(ngModel)]="entityId"
             (change)="entityIdChange.emit($event?.Id)"
             bindLabel="DisplayName"
             groupBy="PhysicalDimensionClv"
             bindValue="Id" appendTo="body">
    <ng-template ng-optgroup-tmp let-item="item">
      {{(classificatorValuesQuery.selectEntity(item.PhysicalDimensionClv) | async)?.Code || 'Unknown' }}
    </ng-template>
    <ng-template ng-footer-tmp>
      <button type="button" *ngIf="entityId" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); editUnit()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
      </button>
      <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); addNewUnit()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
      </button>
    </ng-template>
    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); addNewUnit(searchTerm)">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
          {{t('Add')}} "{{searchTerm}}"
        </button>
      </div>
    </ng-template>
  </ng-select>
</ng-container>
